const devUrls = {
  strapiCMS: "https://blog-cms.reelo.io",
  s3BaseUrl: "https://reelo-uploads-dev.s3.ap-south-1.amazonaws.com",
};
const stagingUrls = {
  strapiCMS: "https://blog-cms.reelo.io",
  s3BaseUrl: "https://reelo-uploads-staging.s3.ap-south-1.amazonaws.com",
};
const prodUrls = {
  strapiCMS: "https://blog-cms.reelo.io",
  s3BaseUrl: "https://reelo-uploads-production.s3.ap-south-1.amazonaws.com",
};

let exportedUrls = devUrls;

if (import.meta.env.VITE_CUSTOM_NODE_ENV === "production") {
  exportedUrls = prodUrls;
} else if (import.meta.env.VITE_CUSTOM_NODE_ENV === "staging") {
  exportedUrls = stagingUrls;
}

export default exportedUrls;
